import { useEffect } from "react"
import { useLocation } from "react-router-dom"

import AmplitudeAnalytics from "#classes/AmplitudeAnalytics"
import { ANALYTICS_EVENTS } from "#classes/FirebaseAnalytics"
import { useUserContext } from "#contexts/UserContextProvider"

const UNKNOWN_USER_ID = "Unknown userId"

export const useAnalytics = () => {
  const location = useLocation()
  const { currentUserId, role, currentUser } = useUserContext()
  const userId = currentUserId ?? UNKNOWN_USER_ID

  // Initialize once on mount
  useEffect(() => {
    AmplitudeAnalytics.initialize()
  }, [])

  // Update user when it changes
  useEffect(() => {
    if (userId === UNKNOWN_USER_ID || !currentUser) return
    AmplitudeAnalytics.setUser(userId, role, currentUser.role ?? null)
  }, [userId, role, currentUser])

  // Page view tracking helper that uses current location
  const trackPageView = (screenName?: string) => {
    const page = screenName || location.pathname
    AmplitudeAnalytics.trackPageView(page)
  }

  return {
    trackEvent: AmplitudeAnalytics.trackEvent,
    trackPageView,
    trackUserPinMissing: AmplitudeAnalytics.trackUserPinMissing,
    trackClassAction: AmplitudeAnalytics.trackClassAction,
    trackStudentAction: AmplitudeAnalytics.trackStudentAction,
    trackStudentEnrollmentAction:
      AmplitudeAnalytics.trackStudentEnrollmentAction,
    trackTeacherEnrollmentAction:
      AmplitudeAnalytics.trackTeacherEnrollmentAction,
    trackAssistantEnrollmentAction:
      AmplitudeAnalytics.trackAssistantEnrollmentAction,
    trackTryoutAction: AmplitudeAnalytics.trackTryoutAction,
    trackMakeupAction: AmplitudeAnalytics.trackMakeupAction,
    trackCurriculumAction: AmplitudeAnalytics.trackCurriculumAction,
    trackProjectAction: AmplitudeAnalytics.trackProjectAction,
    trackAttendanceAction: AmplitudeAnalytics.trackAttendanceAction,
    trackEvaluationAction: AmplitudeAnalytics.trackEvaluationAction,
    trackError: AmplitudeAnalytics.trackError,
    trackModalAction: AmplitudeAnalytics.trackModalAction,
    trackLoadTime: AmplitudeAnalytics.trackLoadTime,
    trackImpersonationStarted: AmplitudeAnalytics.trackImpersonationStarted,
    trackImpersonationStopped: AmplitudeAnalytics.trackImpersonationStopped,
    trackStandoutAction: AmplitudeAnalytics.trackStandoutAction,
    ANALYTICS_EVENTS,
  }
}

export default useAnalytics
